export default "__VITE_ASSET__74c5c697__"